import React, {useRef, useState} from "react";

import data from './UseCases.json';
import styles from './UseCasesSection.module.css';

const UseCasesSection = () => {
  const lastTabRef = useRef(null);
  const firstTabRef = useRef(null);
  const [activeTab, setActiveTab] = useState(0);
  const { label, icon, desc, useCases, quote, quoteAuthor } = data[activeTab];

  const onTabSelected = (i) => setActiveTab(i);
  const onScroll = (ref) => ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

  return <div className={styles.section}>
    <h2 className={`${styles.title} text-lg-start bold color-purple`}>Yes, it's for you</h2>
    <div className="flex mt-5">
      <button className={styles.scrollBtn} onClick={() => onScroll(firstTabRef)}>
        <img
          src="assets/icons/left.png"
          height={20}
          width={20}
          style={{ verticalAlign: 'text-top', opacity: 0.7 }}
        />
      </button>
      <div className={`${styles.tabContainer} hide-scroll`}>
        {data.map((useCase, i) => <button
          className={`${styles.tab} ${useCase.label === label ? styles.activeTab : ''}`}
          onClick={() => onTabSelected(i)}
          ref={i ===0 ? firstTabRef : i === 7 ? lastTabRef : undefined}
        >
          <img
            className={`${useCase.label === label ? styles.whiteFilter : ''} me-2 mb-1`}
            src={useCase.icon}
            height={15}
            style={{ verticalAlign: 'bottom' }}
          />
          {useCase.label}
        </button>)}
      </div>
      <button className={styles.scrollBtn} onClick={() => onScroll(lastTabRef)}>
        <img
          src="assets/icons/next.png"
          height={20}
          width={20}
          style={{ verticalAlign: 'text-top', opacity: 0.7 }}
        />
      </button>
    </div>
    <div className={styles.wrapper}>
      <div className={styles.icon}>
        <img className={styles.whiteFilter} src={icon} height={30}/>
      </div>
      <div className="ms-sm-4">
        <div className={styles.descr}>{desc}</div>
        <div className="mt-3">
          <ul className={styles.bullets}>
            {useCases.map(u => <li>{u}</li>)}
          </ul>
        </div>
      </div>
      <div className={`${styles.quote} ms-md-5`}>
        <div className={styles.quoteText}>
          <div>
            "{quote}"
          </div>
          <div className="font-16">
            - {quoteAuthor}
          </div>
        </div>
      </div>
    </div>
  </div>
}

export default UseCasesSection;